import React, { useEffect, useRef, useState } from "react";
import {
  setDocumentPath,
  showDocumentModalFunc,
} from "../../../config/redux/slice/appSlice";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import { PrintCertificateDoc } from "../Print/PrintCertificateDoc";
import { getExtension } from "../../../helpers/helpers";
import { image_extensions } from "../../../constants/english";

export default function ApplicationDocuments({
  certificateObject,
  additionalDocs,
}) {
  const dispatch = useDispatch();
  const documentPrintRef = useRef(null);
  const promiseResolveRef = useRef(null);
  // const coverLetterPrintRef =  useRef(null)
  // const invoicePrintRef =  useRef(null)
  const [isPrinting, setIsPrinting] = useState(false);

  const {
    userData: { user_role },
  } = useSelector((state) => state.authData);

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const {
    certificateManagement: { document_file_path },
  } = useSelector((state) => state.app);

  return (
    <div className="card card-default">
      <div className="card-body p-0 p-sm-6">
        <div style={{ display: "none" }}>
          <PrintCertificateDoc
            filePath={document_file_path}
            ref={documentPrintRef}
          />
        </div>
        <ul className="list-group">
          <li
            style={{ rowGap: "0.6rem" }}
            className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
          >
            Certificate
            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                onClick={() => {
                  dispatch(
                    showDocumentModalFunc({
                      modal: true,
                      url: certificateObject?.CERTIFICATE_FILE_PATH,
                    }),
                  );
                }}
                className="btn btn-sm btn-primary mr-1"
              >
                <i
                  style={{ fontSize: "1rem" }}
                  className="mdi mdi-folder-open mr-1"
                ></i>
                View Document
              </button>
              {image_extensions.includes(
                getExtension(
                  certificateObject?.CERTIFICATE_FILE_PATH,
                ).toLowerCase(),
              ) ? (
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-primary">
                      <i
                        style={{ fontSize: "1rem" }}
                        className="mdi mdi-printer mr-1"
                      ></i>
                      Print
                    </button>
                  )}
                  content={() => documentPrintRef.current}
                  onBeforeGetContent={() => {
                    return new Promise((resolve) => {
                      promiseResolveRef.current = resolve;
                      dispatch(
                        setDocumentPath({
                          url: certificateObject?.CERTIFICATE_FILE_PATH,
                        }),
                      );
                      setIsPrinting(true);
                    });
                  }}
                  onAfterPrint={() => {
                    // Reset the Promise resolve so we can print again
                    promiseResolveRef.current = null;
                    setIsPrinting(false);
                  }}
                />
              ) : (
                <button className="btn btn-sm btn-primary">
                  <a
                    className="text-white"
                    href={certificateObject?.CERTIFICATE_FILE_PATH}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i
                      style={{ fontSize: "1rem" }}
                      className="mdi mdi-printer mr-1"
                    ></i>
                    Print
                  </a>
                </button>
              )}
            </div>
          </li>
          <li
            style={{ rowGap: "0.6rem" }}
            className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
          >
            Stamped Agreement
            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                onClick={() => {
                  dispatch(
                    showDocumentModalFunc({
                      modal: true,
                      url: certificateObject?.STAMPED_AGREEMENT,
                    }),
                  );
                }}
                className="btn btn-sm btn-primary mr-1"
              >
                <i
                  style={{ fontSize: "1rem" }}
                  className="mdi mdi-folder-open mr-1"
                ></i>
                View Document
              </button>
              {/* <button className='btn btn-sm btn-primary mr-1'>
                <i style={{fontSize: '1rem'}} className="mdi mdi-arrow-down mr-1"></i>
                Download
            </button> */}
              {image_extensions.includes(
                getExtension(
                  certificateObject?.STAMPED_AGREEMENT,
                ).toLowerCase(),
              ) ? (
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-primary">
                      <i
                        style={{ fontSize: "1rem" }}
                        className="mdi mdi-printer mr-1"
                      ></i>
                      Print
                    </button>
                  )}
                  content={() => documentPrintRef.current}
                  onBeforeGetContent={() => {
                    return new Promise((resolve) => {
                      promiseResolveRef.current = resolve;
                      dispatch(
                        setDocumentPath({
                          url: certificateObject?.STAMPED_AGREEMENT,
                        }),
                      );
                      setIsPrinting(true);
                    });
                  }}
                  onAfterPrint={() => {
                    // Reset the Promise resolve so we can print again
                    promiseResolveRef.current = null;
                    setIsPrinting(false);
                  }}
                />
              ) : (
                <button className="btn btn-sm btn-primary">
                  <a
                    className="text-white"
                    href={certificateObject?.STAMPED_AGREEMENT}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i
                      style={{ fontSize: "1rem" }}
                      className="mdi mdi-printer mr-1"
                    ></i>
                    Print
                  </a>
                </button>
              )}
            </div>
          </li>
          <li
            style={{ rowGap: "0.6rem" }}
            className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
          >
            Cover Letter
            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                onClick={() => {
                  dispatch(
                    showDocumentModalFunc({
                      modal: true,
                      url: certificateObject?.COVER_LETTER,
                    }),
                  );
                }}
                className="btn btn-sm btn-primary mr-1"
              >
                <i
                  style={{ fontSize: "1rem" }}
                  className="mdi mdi-folder-open mr-1"
                ></i>
                View Document
              </button>
              {image_extensions.includes(
                getExtension(certificateObject?.COVER_LETTER).toLowerCase(),
              ) ? (
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-primary">
                      <i
                        style={{ fontSize: "1rem" }}
                        className="mdi mdi-printer mr-1"
                      ></i>
                      Print
                    </button>
                  )}
                  content={() => documentPrintRef.current}
                  onBeforeGetContent={() => {
                    return new Promise((resolve) => {
                      promiseResolveRef.current = resolve;
                      dispatch(
                        setDocumentPath({
                          url: certificateObject?.COVER_LETTER,
                        }),
                      );
                      setIsPrinting(true);
                    });
                  }}
                  onAfterPrint={() => {
                    // Reset the Promise resolve so we can print again
                    promiseResolveRef.current = null;
                    setIsPrinting(false);
                  }}
                />
              ) : (
                <button className="btn btn-sm btn-primary">
                  <a
                    className="text-white"
                    href={certificateObject?.COVER_LETTER}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i
                      style={{ fontSize: "1rem" }}
                      className="mdi mdi-printer mr-1"
                    ></i>
                    Print
                  </a>
                </button>
              )}
            </div>
          </li>
          {additionalDocs.map((singleDoc) => {
            return (
              <li
                style={{ rowGap: "0.6rem" }}
                key={singleDoc.ID}
                className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
              >
                {singleDoc.FILE_NAME}
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    onClick={() => {
                      dispatch(
                        showDocumentModalFunc({
                          modal: true,
                          url: singleDoc.FILE_URL,
                        }),
                      );
                    }}
                    className="btn btn-sm btn-primary mr-1"
                  >
                    <i
                      style={{ fontSize: "1rem" }}
                      className="mdi mdi-folder-open mr-1"
                    ></i>
                    View Document
                  </button>
                  {image_extensions.includes(
                    getExtension(singleDoc.FILE_URL).toLowerCase(),
                  ) ? (
                    <ReactToPrint
                      trigger={() => (
                        <button className="btn btn-sm btn-primary">
                          <i
                            style={{ fontSize: "1rem" }}
                            className="mdi mdi-printer mr-1"
                          ></i>
                          Print
                        </button>
                      )}
                      content={() => documentPrintRef.current}
                      onBeforeGetContent={() => {
                        return new Promise((resolve) => {
                          promiseResolveRef.current = resolve;
                          dispatch(
                            setDocumentPath({ url: singleDoc.FILE_URL }),
                          );
                          setIsPrinting(true);
                        });
                      }}
                      onAfterPrint={() => {
                        // Reset the Promise resolve so we can print again
                        promiseResolveRef.current = null;
                        setIsPrinting(false);
                      }}
                    />
                  ) : (
                    <button className="btn btn-sm btn-primary">
                      <a
                        className="text-white"
                        href={singleDoc.FILE_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{ fontSize: "1rem" }}
                          className="mdi mdi-printer mr-1"
                        ></i>
                        Print
                      </a>
                    </button>
                  )}
                </div>
              </li>
            );
          })}
          {certificateObject?.CERTIFY_TRUE_COPY &&
            user_role.toLowerCase() != "transferee_user" && (
              <li className="list-group-item d-flex justify-content-between align-items-center">
                Certified True Copy
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    onClick={() => {
                      dispatch(
                        showDocumentModalFunc({
                          modal: true,
                          url: certificateObject?.CERTIFY_TRUE_COPY,
                        }),
                      );
                    }}
                    className="btn btn-sm btn-primary mr-1"
                  >
                    <i
                      style={{ fontSize: "1rem" }}
                      className="mdi mdi-folder-open mr-1"
                    ></i>
                    View Document
                  </button>
                  {image_extensions.includes(
                    getExtension(
                      certificateObject?.CERTIFY_TRUE_COPY,
                    ).toLowerCase(),
                  ) ? (
                    <ReactToPrint
                      trigger={() => (
                        <button
                          onClick={() => {
                            dispatch(
                              setDocumentPath({
                                url: certificateObject?.CERTIFY_TRUE_COPY,
                              }),
                            );
                          }}
                          className="btn btn-sm btn-primary"
                        >
                          <i
                            style={{ fontSize: "1rem" }}
                            className="mdi mdi-printer mr-1"
                          ></i>
                          Print
                        </button>
                      )}
                      content={() => documentPrintRef.current}
                      onBeforeGetContent={() => {
                        return new Promise((resolve) => {
                          promiseResolveRef.current = resolve;
                          dispatch(
                            setDocumentPath({
                              url: certificateObject?.CERTIFY_TRUE_COPY,
                            }),
                          );
                          setIsPrinting(true);
                        });
                      }}
                      onAfterPrint={() => {
                        // Reset the Promise resolve so we can print again
                        promiseResolveRef.current = null;
                        setIsPrinting(false);
                      }}
                    />
                  ) : (
                    <button className="btn btn-sm btn-primary">
                      <a
                        className="text-white"
                        href={certificateObject?.CERTIFY_TRUE_COPY}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i
                          style={{ fontSize: "1rem" }}
                          className="mdi mdi-printer mr-1"
                        ></i>
                        Print
                      </a>
                    </button>
                  )}
                </div>
              </li>
            )}
        </ul>
      </div>
    </div>
  );
}
